import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { useScrollableWires } from './common/scrollable-wires-hooks';
import Tail from './common/wires-list-tail';
import commonProps from './common/common-props';
import useGetBookmarkedWires from '../../../services/bookmarks-service';
import Wire from './my-bookmarked-wires-components/wire';
import BookmarksEmptyState from './my-bookmarked-wires-components/bookmarks-empty-state';

export default function MyBookmarkedWires({ illustrationUrl, imageUrl }) {
  const common = commonProps();
  const {
    wires, infiniteRef, expandList, showExpand, hasMore, loading,
  } = useScrollableWires({ useGetWires: () => useGetBookmarkedWires() });

  return (
    <ThemeProvider theme={common}>
      <>
        <article>
          {wires.length > 0 && wires.map(wire => <Wire key={`my-bookmarked-wire-${wire.id}`} wire={wire} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all saved wires</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
          {!loading && wires.length === 0 && (
            <BookmarksEmptyState illustrationUrl={illustrationUrl} imageUrl={imageUrl} />
          )}
        </article>
      </>
    </ThemeProvider>
  );
}

MyBookmarkedWires.propTypes = {
  illustrationUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
